
(function ($) { 
    
    Drupal.behaviors.iframeLayer = {

        attach: function (context) {
            Drupal.behaviors.functions.consolog("drupal init iframeLayer");

            $(".iframeLayer", context).each(function (index){   

				if($(this).hasClass("uselayer")){

					$(this).find(".iframeLayerButton").click(function(){
						var $template = $(this).closest(".iframeLayer");
						var iframesrc = $template.attr("data-src");
						var iframesrcArray = iframesrc.split(",");
						var randomSrc = iframesrcArray[Math.floor(Math.random() * iframesrcArray.length)];
						$template.find(".iframeLayerOverlay").find("iframe").attr("src", randomSrc);
						
						$("body").removeClass("prevent-scrolling");
						$("body").addClass("prevent-scrolling");
						
						$template.find(".iframeLayerOverlay").show();
					});
					
					$(this).find(".iframeLayerOverlayButton").click(function(){
						var $template = $(this).closest(".iframeLayer");
						$("body").removeClass("prevent-scrolling");
						$template.find(".iframeLayerOverlay").hide();
					});
				}
				else{
					var $iframeInline = $(this).find(".iframeLayerInline");
					var iframesrc = $(this).attr("data-src");
					var iframesrcArray = iframesrc.split(",");
					var randomSrc = iframesrcArray[Math.floor(Math.random() * iframesrcArray.length)];
					$iframeInline.find("iframe").attr("src", randomSrc);
					$iframeInline.show();
				}

				var $infoCloseBtn = $(this).find(".iframeLayerInfo__close");
				if($infoCloseBtn){
					$infoCloseBtn.click(function(){
						$(this).closest(".iframeLayerInfo").hide();
					});
				}

				$(".iframeLayerFooter").show();

				initScrollListener();
            });

			function initScrollListener(){
                $(window).scroll(handleScroll);
            }

            function handleScroll(){
                var st = $(window).scrollTop();
                var ft = $("footer").offset().top - $(window).height();
            
                if(st > ft){
                    $(".iframeLayerFooter").removeClass("bottom");
                    $(".iframeLayerFooter").addClass("bottom");
                }
                else{
                    $(".iframeLayerFooter").removeClass("bottom");
                }  
                
            }
        }
    };

    
})(jQuery);
